// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"528":"0101d018","647":"50af2939","677":"27c930eb","803":"6f4ab42c"}[chunkId] + ".chunk.css";
};